export enum StorageKey {
  ACCESS_TOKEN_KEY = 'access_token_1',
  REFRESH_TOKEN_KEY = 'refresh_token',
  USER_PROFILE = 'user_profile'
}
